﻿let Default_CustomerSearch_Handler: any = null;
let Default_Bookmark_Handler: any = null;
let Default_History_Handler: any = null;
let Default_FAQ_Handler: any = null;
let Default_ChangeLog_Handler: any = null;
let AllConnectAccessGroupPattern: string = "DL-PF01-RMSJumps-Portal-A-";

namespace WebPortal.Page.Default {
    export class DefaultPage extends Basepage implements IPage {
        public PageLoad(sender: any, e: any) {
            navigationController = new WebPortal.Navigation.Default.NavigationDefaultController();

            super.PageLoad(sender, e);
            if (!LoginRequired) {
                navigationHandler = new WebPortal.Navigation.Default.NavigationDefaultHandler();
                Default_CustomerSearch_Handler = new WebPortal.Default.CustomerSearchHandler();
                Default_Bookmark_Handler = new WebPortal.Default.BookmarkHandler();
                Default_History_Handler = new WebPortal.Default.HistoryHandler();
                Default_FAQ_Handler = new WebPortal.Default.FAQHandler();
                Default_ChangeLog_Handler = new WebPortal.Default.ChangeLogHandler();
            }

            console.log("Initialize ChangePasswordModal")
            // initialisierung ChangePassword resp. Validation
            ChangePasswordModal = new WebPortal.Dialog.Modal.ChangePassword();
            let validation: WebPortal.Validation = new WebPortal.Validation(ChangePasswordModal);

            // Überprüfung, ob die Information zum baldigen Passwortwechsel angezeigt werden soll
            if (!!$("#hdf_nextpasswordcheck").val()) {
                ChangePasswordModal.show($("#hdf_nextpasswordcheck").val());
            } else {
                if (!!navigationHandler) {
                    (navigationHandler as WebPortal.Navigation.Default.NavigationDefaultHandler).showModalIfInternetExplorerDetected();
                }
            }

            // Muss aufgrund von fehlenden AllConnect Connections entfernt werden (NCFEB2B-6650)
            //this.handleAllConnectAutoShow();
        }

        private handleAllConnectAutoShow() {
            // Change LocalStorage Item Status für das Allconnect Zertifikat Download Modal
            $('#cb_modal_download_allconnect_show_modal').on('change', function (e: JQueryEventObject) {
                localStorage.setItem('showAllConnect', $(e.currentTarget).prop("checked"));
            });

            if ($('#hdf_settings').val() !== "") {
                const settings = JSON.parse($('#hdf_settings').val());

                // Zeitgt das Allconnect Zertifikat Download Modal automatisch nach dem Login oder Tenantselection wenn die Checkbox aktiv ist.
                if (settings['AllConnectAccessGroups'] && settings['AllConnectAccessGroups'].length > 0) {
                    const showAllConnect = JSON.parse(localStorage.getItem('showAllConnect'));
                    // Check on ein Eintrag exisitert, sonst initial setzen.
                    if (showAllConnect === null) {
                        $('#cb_modal_download_allconnect_show_modal').prop("checked", true);
                        localStorage.setItem('showAllConnect', 'true');
                        $("#navigation_footer_lbt_download_allconnect_certificate").click();
                    }
                    else {
                        $('#cb_modal_download_allconnect_show_modal').prop("checked", showAllConnect);

                        if (showAllConnect) {
                            $("#navigation_footer_lbt_download_allconnect_certificate").click();
                        }
                    }
                }
            }
        }

        protected connectToHub() {
            let DefaultHub = new WebPortal.Hub.Default.DefaultHub();
            WebPortalHubObj = DefaultHub.WebPortalHub();
        }

        public PageUnLoad() {
            this.RevokeAllConnectCertificates();
            super.PageUnLoad();
        };

        public action_onKeepAlive_Default() {
            (navigationHandler as WebPortal.Navigation.Default.NavigationDefaultHandler).checkWorkingStateTimer();
        };

        public RevokeAllConnectCertificates() {
            let requestParam = $("#hdf_se_request_param").val();

            if (!!requestParam) {
                for (var AccessGroup in AllConnectRBMAs) {
                    let RMBA: string = AccessGroup.replace(AllConnectAccessGroupPattern, "").toLowerCase();
                    WebPortalHubObj.server.doAllConnectRevokeOpenVPNCertificate(requestParam, RMBA);
                }
            }
        }
    }
}

// Benutzer hat Interaktion mit dem Fenster
$(window).mousedown(function () {
    LastActivity = new Date();
});

$(document).keypress(function () {
    LastActivity = new Date();
});